module.exports = __webpack_public_path__ + "img/mascani.a4b9041d.png";